import { render, staticRenderFns } from "./AndesFooter.vue?vue&type=template&id=69b2f96a&"
import script from "./AndesFooter.vue?vue&type=script&lang=js&"
export * from "./AndesFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports